import { Big } from 'big.js';
import { DisplayData, TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import BreJob from '~/tenants/bre/model/BreJob';
import BreFoldersConfig from '~/tenants/bre/performable/print/folders/BreFoldersConfig';
import { BreFoldersPay, BreFoldersRate } from '~/tenants/bre/performable/print/folders/BreFoldersData';
import { BreProviderId } from '~/tenants/bre/model/BreProvider';
import { datetime } from '~/lib/datettime';

export default class BreFoldersJob extends BreJob<typeof BreFoldersConfig> {
  get performable(): typeof BreFoldersConfig {
    return BreFoldersConfig;
  }

  get configurable(): boolean {
    return true;
  }

  get eligible(): boolean {
    return false;
  }

  isDelivery(): boolean {
    return true;
  }

  isPrint(): boolean {
    return true;
  }

  isFreeDelivery(): boolean {
    return true;
  }

  get assignee(): string | null {
    return BreProviderId.PRINT_TEAM.toString();
  }

  info(): DisplayData[] {
    const info = super.info();

    info.push({
      name: 'Count',
      value: this.metadata.count,
      provider: true,
    });

    info.push({
      name: 'Need By',
      value: datetime(this.metadata.need_by, this.order.location.timezone).toFormat('LLL dd, yyyy'),
      provider: true,
    });

    return info;
  }

  defaultValue(): ZodVersionedMetadata<(typeof BreFoldersConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      count: '250',
      need_by: datetime(this.order.created, this.order.timezone).toSQLDate(),
    };
  }

  revenueLines(): TenantJobLine[] {
    const { count } = this.metadata;
    const rate = BreFoldersRate[count];
    const lines: TenantJobLine[] = [];

    if (rate) {
      lines.push({
        id: 'folders_print',
        description: `Presentation folders (x${count})`,
        amount: new Big(rate),
        taxable: true,
      });
    }

    return lines;
  }

  expenseLines(): TenantJobLine[] {
    const { count } = this.metadata;
    const pay = BreFoldersPay[count];
    const lines: TenantJobLine[] = [];

    if (pay) {
      lines.push({
        id: 'folders_print',
        description: `Presentation folders (x${count})`,
        amount: new Big(pay),
      });
    }

    return lines;
  }
}
